export function AssetImage({ src, alt = "", className = "", width, height, onError }) {
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      draggable={false}
      onError={onError}
    />
  );
}
